import { useIsDarkMode } from '@/contexts/ThemeContext';

// Floor-plan rendering parity between light and dark:
// - In light mode, `roomFill` (#FFFFFF) blends into the #fafafa canvas so the
//   architectural floor-plan backdrop shows through; rooms are defined by a
//   near-black stroke. Each room is visually distinct because the stroke has
//   massive luminance contrast against bg+fill.
// - Dark mode needs the same trick: a fill close to the canvas bg (so the
//   backdrop shows through and rooms don't blob together) + a near-white
//   stroke that actually defines each room.
export function useCanvasColors() {
  const isDark = useIsDarkMode();
  return {
    roomFill: isDark ? '#2c2e36' : '#FFFFFF',
    roomFillDetailed: isDark ? '#3c3d49' : '#DADADC',
    roomStroke: isDark ? '#F9F9FA' : '#24252C',
    roomStrokeIdle: isDark ? '#DBDBE1' : '#BEBECA',
    zoneStrokeIdle: isDark ? '#DBDBE1' : '#CECEDA',
    textFill: isDark ? '#F9F9FA' : 'black',
    labelBg: isDark ? '#535565' : 'black',
    sensorLabelBg: isDark ? '#3C3D49' : undefined,
    hiveIconBg: isDark ? '#3C3D49' : 'white',
    canvasBg: isDark ? '#24252C' : '#fafafa',
    canvasBorder: isDark ? '#535565' : '#dddddd',
  };
}
